import React, { useMemo } from "react";
import FormHelperText from "@mui/material/FormHelperText";
import { theme } from "../../themes/GeneralTheme";

const HelperText = ({ error }) => {
  const helperText = useMemo(() => {
    if (error) {
      return error;
    }

    return "";
  }, [error]);

  return (
    <FormHelperText
      sx={{
        mt: 4,
        ml: 0,
        color: theme.palette.error.main,
        fontWeight: 700,
        fontSize: 16,
        lineHeight: 1.28,
      }}
    >
      {helperText}
    </FormHelperText>
  );
};

export default HelperText;
